import notify from 'components/atoms/Notify'
import isEmpty from 'lodash/isEmpty'
import { parseCookies } from 'nookies'
import i18n from '../../i18n'
import refreshToken from './refreshToken'

const baseUrl = process.env.REACT_APP_BASE_URL

const apiPost = async (query, formData, retryCount = 0, showError = true) => {
  const { accessToken, dashboardRole } = parseCookies()

  const isFormData = formData instanceof FormData

  const config = {
    method: 'POST',
    body: isFormData ? formData : JSON.stringify(formData),
  }

  if (!isFormData) {
    config.headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Accept-Language': i18n.language || 'en',
    }
  } else {
    config.headers = {
      'Accept-Language': i18n.language || 'en',
    }
  }

  if (!isEmpty(accessToken)) {
    config.headers = {
      Authorization: accessToken,
      ...config.headers,
    }
    if (dashboardRole) {
      config.headers['X-Dashboard-Role'] = dashboardRole
    }
  }

  const response = await fetch(`${baseUrl}/admin/${query}`, config)
  const responseData = await response.json()

  // Check if token expired (401 Unauthorized)
  if (response.status === 403 && retryCount === 0) {
    const refreshed = await refreshToken()
    if (refreshed) {
      // Retry the request with new token
      return apiPost(query, formData, retryCount + 1, showError)
    } else {
      // Refresh failed, return the error response
      notify.error(responseData.message || 'Session expired. Please login again.', null, responseData.err)
      return responseData
    }
  }

  // if (response.status !== 200) throw new Error('Some error occurred')
  if (!responseData.success && showError) {
    notify.error(responseData.message, null, responseData.err)
  }
  return responseData
}

export default apiPost

export const crmApiCreateLead = payload => apiPost('crm/leads', payload)
export const crmApiAddLeadContact = (leadId, payload) => apiPost(`crm/leads/${leadId}/contacts`, payload)
export const crmApiCreateLeadMagicLink = (leadId, payload) => apiPost(`crm/leads/${leadId}/document-magic-link`, payload)
